import { HStack, Separator, Text } from "@chakra-ui/react";

const OrSeparator = () => {
  return (
    <HStack>
      <Separator flex="1" borderColor="border.light" />
      <Text flexShrink="0" fontSize="xs" color="text.secondary">
        Or
      </Text>
      <Separator flex="1" borderColor="border.light" />
    </HStack>
  );
};

export default OrSeparator;
